import { render, staticRenderFns } from "./SupportTest.vue?vue&type=template&id=292422e4&scoped=true"
import script from "./SupportTest.vue?vue&type=script&lang=js"
export * from "./SupportTest.vue?vue&type=script&lang=js"
import style0 from "./SupportTest.vue?vue&type=style&index=0&id=292422e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292422e4",
  null
  
)

export default component.exports